module.exports = __webpack_public_path__ + "static/p2-46ac38b42d3f89fed22dd3c24948dfe9.svg";